import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import weixin from '../weixin';
import config from './config';
import env from '../env';
import Version from '../Version';
import Clipboard from '../clipboard';
import { getPwd } from './pwd/pwd';
import { openPopUp } from './pwd/popup';
import { openMiddlePage } from './utils/helpers';
var APP_APP_ID = 'wxca942bbff22e0e51'; // 腾讯视频appId

var DEFAULT_KOULING_IMG = 'https://vfiles.gtimg.cn/vupload/20211026/c4b4061635216326216.png';
var DEFAULT_KOULING_TITLE = '腾讯视频为您推荐精彩活动，快来参与吧';
var WECHAT_SINGLE_PAGE_ID = 9999;
export var canGetInstallState = true;
export function ready() {
  return new Promise(function (resolve) {
    if (typeof WeixinJSBridge === 'undefined') {
      document.addEventListener('WeixinJSBridgeReady', resolve, false);
    } else {
      resolve();
    }
  });
}
export function getInstallState() {
  return _getInstallState.apply(this, arguments);
}

function _getInstallState() {
  _getInstallState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var conf,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            conf = _args.length > 0 && _args[0] !== undefined ? _args[0] : config;
            _context.next = 3;
            return ready();

          case 3:
            return _context.abrupt("return", new Promise(function (resolve) {
              WeixinJSBridge.invoke('getInstallState', {
                packageName: conf.packageName,
                packageUrl: conf.packageUrl
              }, function (n) {
                var o = n.err_msg || n.errMsg; // `errMsg`是用于兼容macOs微信模拟器报错,真实环境应该是`err_msg`

                // `errMsg`是用于兼容macOs微信模拟器报错,真实环境应该是`err_msg`
                if (o.indexOf('get_install_state:yes') > -1) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              });
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getInstallState.apply(this, arguments);
}

function weixinReady() {
  return _weixinReady.apply(this, arguments);
}

function _weixinReady() {
  _weixinReady = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve) {
              weixin.weixinReady(resolve);
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _weixinReady.apply(this, arguments);
}

export function launch(_x, _x2) {
  return _launch.apply(this, arguments);
}

function _launch() {
  _launch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(schemeUrl, options) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return weixinReady();

          case 2:
            return _context4.abrupt("return", new Promise(function (resolve) {
              var ua = navigator.userAgent;
              var versionStrArr = ua.match(/MicroMessenger\/([\d.]+)/);
              var kouling = '';
              /**
               * 判断是否无权限拉起 app
               * @param {*} res 微信回包
               * @returns {Boolean}
               */

              /**
               * 判断是否无权限拉起 app
               * @param {*} res 微信回包
               * @returns {Boolean}
               */
              var noPermission = function noPermission(res) {
                if (res && res.err_msg) {
                  // ios android err msg not the same em...
                  return res.err_msg.indexOf('no permission') > -1 || res.err_msg.indexOf('access_denied') > -1;
                }

                return false;
              };
              /**
               * 跳转中间页
               */


              /**
               * 跳转中间页
               */
              var jumpOpenAppPage = function jumpOpenAppPage() {
                if (window.location.href.indexOf('/h5/app/openapp') === -1) {
                  // openapp 页面不跳转了
                  var link = "https://film.qq.com/h5/app/openapp.html?schema=".concat(encodeURIComponent(schemeUrl));
                  window.location.href = link;
                }
              };
              /**
               * 打开口令 ui 弹窗
               */


              /**
               * 打开口令 ui 弹窗
               */
              var showPopup = function showPopup() {
                openPopUp(copyKouling);
              };
              /**
               * 复制口令
               */


              /**
               * 复制口令
               */
              var copyKouling = function copyKouling() {
                new Clipboard({
                  text: kouling,
                  success: function success() {},
                  error: function error() {
                    jumpOpenAppPage();
                  }
                });
              };
              /**
               * 生成口令
               */


              /**
               * 生成口令
               */
              var getKouling = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  var params, result;
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;
                          params = {
                            pageId: WECHAT_SINGLE_PAGE_ID,
                            jumpUrl: encodeURIComponent("txvideo://v.qq.com/Html5Activity?url=".concat(encodeURIComponent(window.location.href))),
                            overlapUrl: DEFAULT_KOULING_IMG,
                            title: DEFAULT_KOULING_TITLE
                          };

                          if (options) {
                            params.title = options.title || DEFAULT_KOULING_TITLE;
                            params.overlapUrl = options.img || DEFAULT_KOULING_IMG;

                            if (options.keepUrl) {
                              params.jumpUrl = encodeURIComponent(schemeUrl);
                            }
                          }

                          _context3.next = 5;
                          return getPwd(params);

                        case 5:
                          result = _context3.sent;
                          kouling = result.weixin[0].text;
                          showPopup();
                          _context3.next = 14;
                          break;

                        case 10:
                          _context3.prev = 10;
                          _context3.t0 = _context3["catch"](0);
                          console.error(_context3.t0);
                          jumpOpenAppPage();

                        case 14:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[0, 10]]);
                }));

                return function getKouling() {
                  return _ref.apply(this, arguments);
                };
              }();

              if (versionStrArr && versionStrArr.length === 2 && Version.compare(versionStrArr[1], '6.5.6')) {
                if (ua.indexOf('iPad') !== -1 || !schemeUrl.match(/^(tenvideo2|txvideo):\/\//)) {
                  try {
                    WeixinJSBridge.invoke('launchApplication', {
                      schemeUrl: schemeUrl
                    }, function (res) {
                      if (noPermission(res)) {
                        getKouling();
                      }

                      resolve(res);
                    });
                  } catch (e) {}
                } else {
                  wx.invoke('launchApplication', {
                    appID: APP_APP_ID,
                    extInfo: schemeUrl,
                    parameter: schemeUrl
                  }, function (res) {
                    if (noPermission(res)) {
                      getKouling();
                    }

                    resolve(res);
                  });
                }
              } else {
                window.location.href = schemeUrl;
              }
            }));

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _launch.apply(this, arguments);
}

export function download() {
  return _download.apply(this, arguments);
}

function _download() {
  _download = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var conf,
        isOpenAppPage,
        _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            conf = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : config;
            isOpenAppPage = openMiddlePage(); // 只有 openapp 中间页才拉起下载

            if (isOpenAppPage) {
              _context5.next = 4;
              break;
            }

            return _context5.abrupt("return");

          case 4:
            if (!env.isIos) {
              _context5.next = 6;
              break;
            }

            return _context5.abrupt("return", new Promise(function (resolve) {
              WeixinJSBridge && WeixinJSBridge.invoke('launchApplication', {
                schemeUrl: conf.download
              }, function (res) {
                resolve(res);
              });
            }));

          case 6:
            if (env.isAndroid) {
              window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.tencent.qqlive';
            }

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _download.apply(this, arguments);
}

export default {
  canGetInstallState: canGetInstallState,
  ready: ready,
  getInstallState: getInstallState,
  launch: launch,
  download: download
};